angular.module('unica_auth.auth_services')

.service('Session', function () {

	this.token     = null;
	this.id        = null;
	this.username  = null;
	this.firstName = null;
	this.lastName  = null;
	this.role      = null;
	this.subRole   = null;
	this.managerMediaPermission   = null;

	this.create = function (sessionId, id, username, firstName, lastName, role, subRole, managerMediaPermission) {
		this.token      = sessionId;
		this.id         = id;
		this.username   = username;
		this.firstName  = firstName;
		this.lastName   = lastName;
		this.role       = role;
		this.subRole    = subRole;
		this.managerMediaPermission    = managerMediaPermission;


		localStorage.removeItem('session');
		var obj = {
			token:      this.token,
			id:         this.id,
			username:   this.username,
			first_name: this.firstName,
			last_name:  this.lastName,
			role:       this.role,
			sub_role:   this.subRole,
			manager_media_permission:   this.managerMediaPermission
		};

		localStorage.setItem('session', JSON.stringify(obj));
	};

	this.destroy = function () {
		this.token     = null;
		this.id        = null;
		this.username  = null;
		this.firstName = null;
		this.lastName  = null;
		this.role      = null;
		this.subRole   = null;
		this.managerMediaPermission   = null;
		localStorage.removeItem('session');
	};

	return this;
})

.factory('AuthService', function ($http, getBaseApiURL, Session) {

	var authService = {};

	authService.getUser = function () {
		return $http({
			method: 'GET',
			url: getBaseApiURL + '/auth/me',
			withCredentials: true
		}).then(function(response) {
			return response.data || null;
		}).catch(function() {
			return null;
		});
	};

	return authService;

});
